(function(window, angular) {
    "user strict";
    var m = angular.module("vvCommon");

    m.service('vvRegister', function($http, vvConnect, vvPopup, gettextCatalog) {
        var deregisterInAction = false;
        this.deregister = function () {
            vvConnect.checkConnected(true)
              .then(function(user) {
                if (deregisterInAction)
                return;

                deregisterInAction = true;
                vvPopup.confirm(gettextCatalog.getString('삭제한 계정 정보는 복구할 수 없습니다.\n\n삭제하시겠습니까?'))
                .then(function(action) {
                  if (action === 'confirm') {
                    var apiPath = '/api/deregister/' + user.fb_id;
                    $http.post(apiPath, null)
                    .success(function(data, status, headers, config) {
                      vvConnect.deregister()
                      .then(function(success) {
                        console.log('vvConnect.deregister success');
                        var msg = gettextCatalog.getString('계정 정보 삭제가 완료되었습니다.');

                        if (!success) {
                          var scat = vv.getVvMetaData('scat');
                          if (scat == 'vonvon')
                          msg += '\n\n' + gettextCatalog.getString('SNS 연동 정보 삭제는 해당 SNS에서 설정하시기 바랍니다.');
                          else if (scat == 'wooof')
                          msg += '\n\n' + gettextCatalog.getString('[wooof] SNS 연동 정보 삭제는 해당 SNS에서 설정하시기 바랍니다.');
                        }

                        vvPopup.alert(msg);
                        vvConnect.disconnect();
                        deregisterInAction = false;
                        window.location.href = '/';
                      });
                    })
                    .error(function(data, status, headers, config) {
                      console.log(apiPath, status, data);
                      alert('Error: ' + status);
                      deregisterInAction = false;
                    });
                  } else
                  deregisterInAction = false;
                });
              }, function() {
                vvPopup.alert(gettextCatalog.getString('계정 정보 삭제를 위해서는 로그인이 필요합니다.'));
              });
        }
    })
})(window, window.angular);